import React, { useState } from "react";
import {
  UilCloudUpload,
  UilTrashAlt,
  UilCheckCircle,
} from "@iconscout/react-unicons";
import { useNavigate, useSearchParams } from "react-router-dom";
import AddMovieHeader from "../components/AddMovieHeader";
import PageHeader from "../components/Header";
import { useAddMovie } from "contexts/AdsMovieContext";
// import { uploadFile } from "../components/uploadFile";
import { toast } from "react-toastify";

export default function MovieUpload({ onCancel, details }) {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [uploaded, setUploaded] = useState(false);
  const [controller, setController] = useState(null);

  const { dispatch } = useAddMovie();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const handleCancel = () => {
    if (typeof onCancel === "function") onCancel();
    navigate(-1);
  };

  const handleFileChange = async (e) => {
    const newFile = e.target.files[0];
    if (!newFile) return;

    setFile(newFile);
    setUploading(false);
    setProgress(0);
    setUploaded(false);

    setController(null);
    dispatch({ type: "SET_FIELD", field: "movieFile", value: newFile });
  };

  console.log("details");
  const handleSubmitUpload = async () => {
    if (!file || uploading) return;

    setUploading(true);
    setProgress(0);
    setUploaded(false);

    const ctrl = new AbortController();
    setController(ctrl);

    try {
      // await uploadFile({
      //   name: "movie",
      //   file,
      //   mediaId: searchParams.get("id"),
      //   type: "movie",
      //   signal: ctrl.signal,
      //   onProgress: ({ percent }) => setProgress(percent || 0),
      // });
      setUploading(false);
      setUploaded(true);
      setProgress(100);
      toast.success("Movie uploaded successfully");
      navigate(
        "/movie-box/add-movie/add-trailer" +
          (searchParams.get("id") ? `?id=${searchParams.get("id")}` : "")
      );
    } catch (error) {
      setUploading(false);
      setUploaded(false);
      console.error(error);
      toast.error("Error uploading movie. Please try again.");
    } finally {
      setController(null);
    }
  };

  const removeFile = () => {
    if (uploading && controller) controller.abort();
    setFile(null);
    setProgress(0);
    setUploading(false);
    setUploaded(false);
    setController(null);
    dispatch({ type: "SET_FIELD", field: "movieFile", value: null });
  };

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <AddMovieHeader
        onCancel={handleCancel}
        showProgress={true}
        currentStep={4}
        continueDisabled={!file || uploading}
        onContinue={handleSubmitUpload}
      />

      <main className="flex-1 flex justify-center px-4 py-8">
        <div className="w-full max-w-3xl">
          <PageHeader
            title="Upload a Movie File"
            description="Add the final video file your audience will watch. Make sure it’s high quality and meets our guidelines."
          />

          <div className="relative mt-6">
            <span className="absolute -top-5 left-0 text-sm font-semibold text-gray-700">
              Movie File
            </span>

            <div className="bg-blue-50 border-2 border-dashed rounded-md p-4 flex flex-col justify-center">
              {!file && (
                <label className="flex items-center cursor-pointer space-x-3">
                  <UilCloudUpload className="text-blue-500 h-6 w-6" />
                  <div>
                    <p className="text-blue-600 font-medium">
                      Upload your movie file (MP4, MOV, AVI)
                    </p>
                    <p className="text-xs text-gray-600 mt-1">
                      MP4, MOV, AVI supported
                    </p>
                  </div>
                  <input
                    type="file"
                    accept=".mp4,.mov,.avi"
                    className="hidden"
                    onChange={handleFileChange}
                  />
                </label>
              )}

              {file && uploading && (
                <div className="w-full">
                  <p className="text-sm text-gray-800">{file.name}</p>
                  <div className="flex items-center mt-2">
                    <div className="flex-1 h-2 bg-gray-200 rounded-full overflow-hidden">
                      <div
                        className="h-full bg-blue-500"
                        style={{ width: `${progress}%` }}
                      ></div>
                    </div>
                    <span className="ml-3 text-sm text-gray-700">
                      {progress}%
                    </span>
                    <button
                      type="button"
                      onClick={removeFile}
                      className="ml-3 text-gray-500 hover:text-red-600"
                    >
                      <UilTrashAlt size={18} />
                    </button>
                  </div>
                  <p className="text-xs text-gray-500 mt-1">Uploading...</p>
                </div>
              )}

              {file && !uploading && !uploaded && (
                <div className="w-full flex items-center justify-between">
                  <div className="flex items-start space-x-2">
                    <UilCloudUpload className="text-blue-500 mt-1" size={18} />
                    <div>
                      <p className="text-sm text-gray-800">{file.name}</p>
                      <p className="text-xs text-gray-500 mt-1">
                        Ready to upload •{" "}
                        {(file.size / (1024 * 1024 * 1024)).toFixed(2)} GB
                      </p>
                    </div>
                  </div>
                  <button
                    type="button"
                    onClick={removeFile}
                    className="text-gray-500 hover:text-red-600"
                  >
                    <UilTrashAlt size={18} />
                  </button>
                </div>
              )}

              {file && uploaded && (
                <div className="w-full flex items-center justify-between">
                  <div className="flex items-start space-x-2">
                    <UilCheckCircle className="text-green-600 mt-1" size={18} />
                    <div>
                      <p className="text-sm text-gray-800">{file.name}</p>
                      <p className="text-xs text-gray-500 mt-1">
                        Uploaded •{" "}
                        {(file.size / (1024 * 1024 * 1024)).toFixed(2)} GB
                      </p>
                    </div>
                  </div>
                  <button
                    type="button"
                    onClick={removeFile}
                    className="text-gray-500 hover:text-red-600"
                  >
                    <UilTrashAlt size={18} />
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
